export default __webpack_public_path__ + "static/media/error-image.54e18ef7.png";